import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

export enum Language {
  English = 'en',
  Spanish = 'es',
  Both = 'both',
}

const translationFileName = process.env.REACT_APP_NYC_MODE === 'true'
  ? "translation-nyc.json" 
  : "translation.json";

export const AVAILABLE_LOCALES = [Language.English, Language.Spanish];

// Build version for cache busting translation files
const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION || 'dev';

/** UI locale only (used for i18n / TRANSLATIONS). */
export type LanguageType = 'en' | 'es';

/** Profile "language spoken" field (en, es, or both). */
export type SpokenLanguage = 'en' | 'es' | 'both';

i18n
  .use(HttpBackend) 
  .use(LanguageDetector)
  .use(initReactI18next) 
  .init({
    fallbackLng: "en", 
    supportedLngs: AVAILABLE_LOCALES,
    debug: process.env.NODE_ENV === "development", 
    interpolation: {
      escapeValue: false, 
    },
    detection: {
      order: ['navigator'],
      caches: [], 
    },
    backend: {
      loadPath: `/locales/{{lng}}/${translationFileName}?v=${BUILD_VERSION}`, 
    },
  });

export default i18n;